/* eslint-disable */

import _ from 'lodash'

export default function (files) {
  if (!files) {
    console.warn('No file to read')

    return null
  }

  let file = files

  if (_.isArray(files)) {
    if (!files.length) {
      console.warn('No file to read')

      return null
    }

    [file] = files
  }
  else if (_.isString(files) && files.startsWith('data:')) {
    return files
  }

  if (!(file instanceof Blob)) {
    console.warn('No file to read')

    return null
  }

  return new Promise((res, rej) => {
    const reader = new FileReader()

    reader.onload = () => {
      if (reader.error) {
        return rej(reader.error)
      }

      return res(reader.result)
    }

    reader.readAsDataURL(file)
  })
}



// WEBPACK FOOTER //
// ./src/readFileAsync.js